import React from 'react';
import { motion } from 'framer-motion';
import { pageData } from './data';
import { BookOpenIcon } from 'lucide-react';
export function Volumes() {
  const {
    volumes
  } = pageData;
  return <section className="py-20 px-4 bg-navy-900 border-y border-white/5" data-id="element-209">
      <div className="max-w-6xl mx-auto" data-id="element-210">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-4xl md:text-5xl text-center mb-16" data-id="element-211">
          {volumes.heading}
        </motion.h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-212">
          {volumes.items.map((item, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-slate-850 border border-slate-800 rounded-2xl p-8 relative overflow-hidden group hover:border-gold-500/30 transition-colors" data-id="element-213">
              <div className="absolute top-0 right-0 p-6 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-214">
                <BookOpenIcon className="w-24 h-24" data-id="element-215" />
              </div>

              <div className="relative z-10" data-id="element-216">
                <div className="text-gold-500 font-display text-sm tracking-widest mb-4" data-id="element-217">
                  {item.volume}
                </div>
                <h3 className="text-2xl mb-1" data-id="element-218">{item.title}</h3>
                <div className="text-sm font-bold text-slate-400 mb-4 uppercase tracking-wider" data-id="element-219">
                  {item.subtitle}
                </div>
                <p className="text-slate-400 leading-relaxed" data-id="element-220">
                  {item.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}